import axios from "axios";

export const getCSVData = async (file) => {
  try {
    const formData = new FormData();
    formData.append("csvFile", file);

    const response = await axios.post("/convert-csv-to-json", formData);

    return response.data.data;
  } catch (error) {}
};


